module["exports"] = [
  "#{city_prefix}#{city_suffix}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/zh_CN/address/city.js
 ** module id = 1108
 ** module chunks = 0
 **/